export default __webpack_public_path__ + "static/media/safe.71fda48f.svg";